module.exports = __webpack_public_path__ + "img/141.666a2682.jpg";